import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCrossFull = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m4.35-8.053c-.39-.39-.706-.717-.706-.717l-2.2-2.2L16.35 9.12a1 1 0 1 0-1.414-1.414l-2.908 2.908-2.908-2.908a1 1 0 0 0-1.414 1.414l2.908 2.908-2.2 2.2s-.317.327-.708.718a.99.99 0 0 0 0 1.404 1 1 0 0 0 1.414 0l2.908-2.908 2.908 2.908a1 1 0 0 0 1.414 0 .99.99 0 0 0 0-1.404"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCrossFull);
export default Memo;
